import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { supabase } from '../utils/supabaseClient';

const FeedbackForm = forwardRef(({ onSubmitted }, ref) => {
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  // Async feedback submission
  const saveFeedback = async () => {
    setError('');
    if (rating === 0 || !feedback.trim()) {
      return false;
    }
    setSaving(true);

    let user_id = null;
    let userName = null;
    try {
      const { data: { user } } = await supabase.auth.getUser();
      user_id = user?.id || null;

      // Fetch the user's name from the accounts table
      if (user_id) {
        const { data: account } = await supabase
          .from('accounts')
          .select('name')
          .eq('id', user_id)
          .single();
        userName = account?.name || '';
      }
    } catch { /* ignore */ }

    const { error: supaError } = await supabase.from('feedback').insert([{
      user_id,
      name: userName,  // <-- Now it's correct!
      rating,
      feedback
    }]);
    setSaving(false);

    if (supaError) {
      setError('Could not save feedback. Please try again.');
      return false;
    }
    setSubmitted(true);
    if (onSubmitted) onSubmitted();
    return true;
  };

  useImperativeHandle(ref, () => ({
    submitForm: async () => {
      return await saveFeedback();
    },
    hasSubmitted: submitted,
    copyCode: () => {
      navigator.clipboard.writeText("VEETRIX5OFF");
    }
  }));

  return (
    <form
      className="feedback-form"
      onSubmit={async e => {
        e.preventDefault();
        await saveFeedback();
      }}
    >
      {submitted ? (
        <div className="feedback-confirmation">
          <h3>Thank you for your feedback!</h3>
          <div className="discount-code-box">
            <p>Here’s your <b>$5 discount code</b>:</p>
            <code style={{ fontSize: 18, letterSpacing: 1 }}>VEETRIX5OFF</code>
            <p style={{marginTop: 8, paddingBottom: 0, fontSize: 13, color: "#666"}}>
              Use this code when upgrading!
            </p>
          </div>
        </div>
      ) : (
        <>
          <h3>We’d love your feedback!</h3>
          <p>How was your experience so far?</p>
          <div className='star-rating'>
            {[1,2,3,4,5].map((n) => (
              <span
                key={n}
                style={{
                  cursor: 'pointer',
                  color: n <= rating ? '#fbbf24' : '#d1d5db'
                }}
                onClick={() => setRating(n)}
                aria-label={n + " star"}
              >★</span>
            ))}
          </div>
          <div>
            <label htmlFor="feedback">What did you like or dislike?</label>
            <textarea
              id="feedback"
              value={feedback}
              onChange={e => setFeedback(e.target.value)}
              placeholder="Please share anything you liked or wish was better…"
              rows={3}
            />
          </div>
          {/* Only show error if it's a real Supabase/network error */}
          {error && <div style={{ color: '#f43f5e', marginTop: 8 }}><p>{error}</p></div>}
          {saving && <div style={{ color: '#888', marginTop: 8 }}><p>Saving…</p></div>}
        </>
      )}
    </form>
  );
});

export default FeedbackForm;
